
import { Lead } from "@/types/lead";

export const downloadCSV = (csvContent: string, filename: string) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const getCSVTemplate = (): string => {
  // Header row with all possible fields
  const headers = [
    'Name', 
    'Address', 
    'Category', 
    'Phone', 
    'Website', 
    'Email',
    'Rating', 
    'ReviewCount',
    'Latitude',
    'Longitude',
    'Notes'
  ];
  
  // Sample data row
  const sampleData = [
    'Acme Corporation',
    '123 Main St, San Francisco, CA 94105',
    'Business Services',
    '(555) 123-4567',
    'https://www.acme.example.com',
    'contact@acme.example.com',
    '4.5',
    '120',
    '37.7749',
    '-122.4194',
    'Initial contact made via website'
  ];
  
  // Another sample row
  const sampleData2 = [
    'Tech Solutions Inc',
    '456 Tech Blvd, Mountain View, CA 94043',
    'Technology',
    '(555) 987-6543',
    'https://www.techsolutions.example',
    'info@techsolutions.example',
    '4.8',
    '85',
    '37.3861',
    '-122.0839',
    'Potential enterprise client'
  ];
  
  // Combine into CSV format
  const csvContent = [
    headers.join(','),
    sampleData.join(','),
    sampleData2.join(',')
  ].join('\n');
  
  return csvContent;
};
